import React from 'react'

import InputV2 from 'components/InputV2'

import {
  Form,
  FormInputs,
  InputsSection,
  CustomInputsRow,
  InputWrapper,
} from './styles'

const SimplePersonalForm = (props) => {
  const {
    name,
    surName,
    email,
    phone,
    changeField,
    loading,
    tab,
    renderBtns,
  } = props

  return (
    !loading &&
    tab === 'simple_personal' && (
      <Form>
        <FormInputs>
          <InputsSection>
            <h4>Dados Pessoais</h4>

            <div className='rowsWrapper'>
              <CustomInputsRow>
                <InputWrapper>
                  <InputV2
                    id='name_input'
                    style={{ width: '100%' }}
                    required
                    label='Nome'
                    type='text'
                    placeholder='Escreva o seu nome'
                    value={name.value}
                    onChange={(val) => changeField('personal', 'name', val)}
                    valid={!Boolean(name.valid)}
                    errorMessage={name.valid}
                  />
                </InputWrapper>

                <InputWrapper>
                  <InputV2
                    id='surName_input'
                    style={{ width: '100%' }}
                    required
                    label='Apelido'
                    type='text'
                    placeholder='Escreva o seu apelido'
                    value={surName.value}
                    onChange={(val) => changeField('personal', 'surName', val)}
                    valid={!Boolean(surName.valid)}
                    errorMessage={surName.valid}
                  />
                </InputWrapper>
              </CustomInputsRow>
            </div>
          </InputsSection>

          <InputsSection>
            <h4>Contatos</h4>

            <div className='rowsWrapper'>
              <CustomInputsRow>
                <InputWrapper>
                  <InputV2
                    id='email_input'
                    style={{ width: '100%' }}
                    required
                    label='Email'
                    type='email'
                    placeholder='Escreva o seu email'
                    value={email.value}
                    onChange={(val) => changeField('personal', 'email', val)}
                    valid={!Boolean(email.valid)}
                    errorMessage={email.valid}
                  />
                </InputWrapper>

                <InputWrapper>
                  <InputV2
                    id='phone_input'
                    style={{ width: '100%' }}
                    required
                    label='Contato'
                    placeholder='Ex: 900 000 000'
                    value={phone.value}
                    valid={!Boolean(phone.valid)}
                    errorMessage={phone.valid}
                    onChange={(val) => {
                      let value = val
                      const sanitized = value.replace(/[^\d+]/g, '')

                      const plusCount = (sanitized.match(/\+/g) || []).length
                      if (plusCount > 1) {
                        value = '+' + sanitized.replace(/\+/g, '')
                      } else if (
                        plusCount === 1 &&
                        sanitized.indexOf('+') !== 0
                      ) {
                        value = '+' + sanitized.replace(/\+/g, '')
                      } else {
                        value = sanitized
                      }

                      changeField('personal', 'phone', value)
                    }}
                    pattern='[\+0-9]*'
                    inputMode='tel'
                    type='text'
                  />
                </InputWrapper>
              </CustomInputsRow>
            </div>
          </InputsSection>
        </FormInputs>
        {renderBtns()}
      </Form>
    )
  )
}

export default SimplePersonalForm



// WEBPACK FOOTER //
// ./src/components/JoinTariffModalV2/mobileComponents/simplePersonalForm.js